import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../components/SafeIcon';
import { products } from '../data/mockData';

const Products = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const getRatingColor = (rating) => {
    if (rating.startsWith('A')) return 'bg-green-100 text-green-800';
    if (rating.startsWith('B')) return 'bg-blue-100 text-blue-800';
    if (rating.startsWith('F')) return 'bg-red-100 text-red-800';
    return 'bg-gray-100 text-gray-800';
  };

  const filteredProducts = products.filter(p => 
    p.name.toLowerCase().includes(searchTerm.toLowerCase()) || 
    p.brand.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="container-custom py-8 min-h-screen">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Product Safety Database</h1>
          <p className="text-gray-600">Search verified testing results for popular moringa supplements.</p>
        </div>
        <div className="relative w-full md:w-64">
          <input
            type="text"
            placeholder="Search brand or product..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary"
          />
          <SafeIcon icon={FiIcons.FiSearch} className="absolute left-3 top-2.5 text-gray-400" />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredProducts.map(product => (
          <div key={product.id} className="bg-white border border-gray-200 rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow">
            <div className="h-48 bg-gray-100 relative">
              <img 
                src={product.image} 
                alt={product.name}
                className="w-full h-full object-cover"
              />
              <div className={`absolute top-4 right-4 text-xl font-bold w-10 h-10 flex items-center justify-center rounded-full shadow-sm ${getRatingColor(product.rating)}`}>
                {product.rating}
              </div>
            </div>
            <div className="p-5">
              <h3 className="font-bold text-lg text-gray-900 mb-1">{product.name}</h3>
              <p className="text-sm text-gray-500 mb-4">{product.brand}</p>
              
              <div className="space-y-2 text-sm">
                <div className="flex justify-between items-center py-1 border-b border-gray-50">
                  <span className="text-gray-500">Safety Status</span>
                  <span className={`font-medium ${product.status === 'Warning' ? 'text-alert' : 'text-green-600'}`}>
                    {product.status}
                  </span>
                </div>
                <div className="flex justify-between items-center py-1 border-b border-gray-50">
                  <span className="text-gray-500">Last Tested</span>
                  <span className="text-gray-800">{product.lastTested}</span>
                </div>
              </div>

              <button className="w-full mt-5 bg-white border border-gray-300 text-gray-700 font-medium py-2 rounded hover:bg-gray-50 transition-colors">
                View Test Report
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Products;